module.exports = __webpack_public_path__ + "static/media/img_2.d9abe9d2.png";